import * as React from 'react';
import { PoiCard } from '../../component/poi-card';
import { InsCard } from '../../component/ins-card';
import { Archor } from '../../component/archor';
import { HashtagItem, LogEventType } from '../../component/hashtag-item';
import { PoiArchorItem } from '../../component/poi-archor';
import {SearchAnchorItem} from '../../component/search-word-anchor';
import { MentionedUserAnchor } from '../../component/mentioned-user-anchor';
import { GoodsCard, GoodsCardData } from '../../component/goods-card';
import { MenuType } from '../../types/global';
import { ArticleMenu } from '../../component/article-menu';

export const genArchorProcessingInstruction = (onLinkClick?: any) => ({
  shouldProcessNode(node: any) {
    const isImage =
      node.attribs &&
      node.attribs.class &&
      node.attribs.class.includes('image');
    const isHashtag =
      node.attribs &&
      node.attribs.class &&
      node.attribs.class.includes('l8editor-forum');
    const isPoiAnchor =
      node.attribs &&
      node.attribs.class &&
      node.attribs.class.includes('l8editor-poi');
    const isMentionedAnchor =
      node.attribs &&
      node.attribs.class &&
      node.attribs.class.includes('l8editor-mention');
    const isSearchAnchor =
      node.attribs &&
      node.attribs.class &&
      node.attribs.class.includes('l8-entity-word');
    return !isImage && !isHashtag && !isPoiAnchor && !isMentionedAnchor && !isSearchAnchor && node.type === 'tag' && node.name === 'a';
  },
  processNode(node: any, children: any) {
    // 因为a标签可能被拦截掉了，所以这里需要用click来触发页面内跳转
    return (
      <Archor {...node.attribs} onLinkClick={onLinkClick}>
        {children}
      </Archor>
    );
  },
});

export const genHashtagProcessingInstruction = (
  onHashtagClick: (href: string, dataId:string) => void,
  onLogEvent: (data: LogEventType) => void,
  countryRegion: string
) => ({
  shouldProcessNode(node: any) {
    const isHashtag =
      node.attribs &&
      node.attribs.class &&
      node.attribs.class.includes('l8editor-forum');
    return isHashtag && node.type === 'tag' && node.name === 'a';
  },
  processNode(node: any) {
    const attr = node.attribs || {};
    const props = {
      dataType: attr['data-type'] || '',
      dataName: node.children?.[0]?.data || '',
      dataId: attr['data-id'] || '',
      dataRegion: countryRegion || attr['data-region']
    };
    return (
      <HashtagItem {...props} onHashtagClick={onHashtagClick} onLogEvent={onLogEvent} />
    );
  },
});

export const genMentionedAnchorInstruction = (
  onMentionedClick: (href: string, dataId:string) => void,
  onLogEvent: (data: LogEventType) => void,
) => ({
  shouldProcessNode(node: any) {
    const isMetionedAnchor =
      node.attribs &&
      node.attribs.class &&
      node.attribs.class.includes('l8editor-mention');
    return isMetionedAnchor && node.type === 'tag' && node.name === 'a';
  },
  processNode(node: any) {
    const attr = node.attribs || {};
    const mentionedName = attr['data-name'] || '';
    const mentionedType = attr['data-type'] || '';
    const props = {
      dataType: mentionedType,
      // User Nickname
      dataName: mentionedName,
      dataId: attr['data-id'] || '',
      href: attr['href'],
    };
    return (
      <MentionedUserAnchor {...props} onMentionedClick={onMentionedClick} onLogEvent={onLogEvent} />
    );
  },
});

export const genSearchAnchorInstruction = (
  onSearchAnchorClick: (word: string) => void,
  onLogEvent: (data: LogEventType) => void,
  countryRegion
) => ({
  shouldProcessNode(node: any) {
    const isSearchAnchor =
      node.attribs &&
      node.attribs.class &&
      node.attribs.class.includes('l8-entity-word');
    return isSearchAnchor && node.type === 'tag' && node.name === 'a';
  },
  processNode(node: any) {
    const attr = node.attribs || {};
    const searchWord = attr['data-name'] || node.children?.[0]?.data || '';
    const type = attr['data-type'] || '';
    const props = {
      dataType: type,
      dataWord: searchWord,
      dataId: attr['data-id'] || '',
      dataRegion: countryRegion
    };
    return (
      <SearchAnchorItem {...props} onSearchAnchorClick={onSearchAnchorClick} onLogEvent={onLogEvent} />
    );
  },
});

export const genPoiArchorProcessingInstruction = (
  onPoiArchorClick: (href: string, dataId:string) => void,
  onLogEvent: (data: LogEventType) => void,
  countryRegion
) => ({
  shouldProcessNode(node: any) {
    const isPoiArchor =
      node.attribs &&
      node.attribs.class &&
      node.attribs.class.includes('l8editor-poi');
    return isPoiArchor && node.name === 'a';
  },
  processNode(node: any) {
    const attr = node.attribs || {};
    const props = {
      dataType: attr['data-type'] || '',
      dataName: attr['data-name'] || '',
      dataId: attr['data-id'] || '',
      dataRegion: countryRegion || attr['data-region']
    };
    return (
      <PoiArchorItem {...props} onPoiArchorClick={onPoiArchorClick} onLogEvent={onLogEvent} />
    );
  },
});

export const genPoiProcessingInstruction = (onPoiClick: any) => ({
  shouldProcessNode(node: any) {
    if (
      node.type === 'tag' &&
      node.name === 'div' &&
      node.attribs &&
      node.attribs.class &&
      node.attribs.class.includes('poi-card')
    ) {
      return true;
    }
    return false;
  },
  processNode(node: any) {
    const attr = node.attribs || {};
    const props = {
      name: attr['data-name'] || '',
      img: attr['data-img'] || '',
      address: attr['data-address'] || '',
      lat: attr['data-lat'] || '',
      lng: attr['data-lng'] || '',
      id: attr['data-id'] || '',
      href: attr['data-href'] || '',
    };
    return <PoiCard {...props} onPoiClick={onPoiClick} />;
  },
});

export const genInsProcessingInstruction = onInsClick => ({
  shouldProcessNode(node: any) {
    if (
      node.type === 'tag' &&
      node.name === 'div' &&
      node.attribs &&
      node.attribs.class &&
      node.attribs.class.includes('ins-container')
    ) {
      return true;
    }
    return false;
  },
  processNode(node: any, children: any) {
    const attr = node.attribs || {};
    const props = {
      dataWidth: attr['data-width'] || '',
      dataHeight: attr['data-height'] || '',
      iframeProps: (children[0] || {}).props || {},
    };
    return <InsCard {...props} onInsClick={onInsClick} />;
  },
});

export const genGoodsProcessingInstruction = (
  onGoodsClick: (data: GoodsCardData) => void,
  onGoodsImpression: (data: GoodsCardData) => void,
) => ({
  shouldProcessNode(node: any) {
    if (
      node.type === 'tag' &&
      node.name === 'div' &&
      node.attribs &&
      node.attribs.class &&
      node.attribs.class.includes('goods-card')
    ) {
      return true;
    }
    return false;
  },
  processNode(node: any) {
    const attr = node.attribs || {};
    const props = {
      href: attr['data-url'] || '',
      name: attr['data-name'] || '',
      origin: attr['data-origin'] || '',
      description: attr['data-description'] || '',
      imgUrl: attr['data-image-url'] || '',
      external_id: attr['data-external-id'] || '',
    };
    return (
      <GoodsCard
        {...props}
        onGoodsClick={onGoodsClick}
        onGoodsImpression={onGoodsImpression}
      />
    );
  },
});

export const genMenuProcessingInstruction = (
  isShow: boolean,
  treeMenu: MenuType[],
  onMenuClick: (data: string) => void,
  onUpdateMenu: () => void,
) => ({
  shouldProcessNode(node: any) {
    if (
      node.type === 'tag' &&
      node.name === 'div' &&
      node.attribs &&
      node.attribs.class &&
      node.attribs?.class?.includes('menu-list') &&
      isShow
    ) {
      return true;
    }
    return false;
  },
  processNode() {
    // node.attribs.class = 'sharee-menu';
    return (
      <ArticleMenu
        menuList={treeMenu}
        onMenuClick={onMenuClick}
        onUpdateMenu={onUpdateMenu}
      />
    );
  },
});
